export enum FormInputNameLogin {
  email = 'email',
  password = 'password',
}

export enum FormInputChangePassowordEmail {
  email = 'email',
}

export enum FormInputChangePassoword {
  code = 'code',
  newPassword = 'newPassword',
  confirmPassword = 'confirmPassword',
}
